<div *ngIf="loader" id="spinerLoader" class="container">
    <div class="loader">Loading...</div>
</div>
<div id="addEditVehicle" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header content-header">
                <button
                    class="close close-btn"
                    aria-label="Close"
                    data-dismiss="modal"
                    type="button"
                    (click)="clearVehicleData(); resetForm(loginForm); emitPopupCloseEvent()"
                >
                    <i class="fa fa-close fa-md"></i>
                </button>
                <h4 class="modal-title">{{ headerName }} {{ serviceType == 'Air' ? 'Aircraft' : 'Vehicle' }}</h4>
            </div>
            <form #loginForm="ngForm" name="loginForm">
                <div class="modal-body">
                    <div class="member-card">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label
                                        >{{ vehicleTitle }} <span class="text-danger"><b>*</b></span>
                                        <span *ngIf="isAircraftCatalogLoading">
                                            <i class="fa fa-spin fa-spinner"></i>
                                        </span>
                                    </label>
                                    <ng-container *ngIf="serviceType == 'Air'; else vehicleNameInput">
                                        <!-- ds-select is reactive-forms-only, so `[ngModel]` is one-way (registration +
                                             required) and the selection is read from `(selectionChange)`. -->
                                        <ds-select
                                            id="vehiclename"
                                            #vehicle_name="ngModel"
                                            name="vehicle_name"
                                            class="mat-form-field-legacy"
                                            required
                                            [placeholder]="aircraftSelectPlaceholder"
                                            [ngClass]="{ 'is-invalid': loginForm.submitted && vehicle_name.invalid }"
                                            [options]="aircraftModelOptions"
                                            [isSearchable]="true"
                                            [compareWith]="compareAircraftModelOptions"
                                            [ngModel]="selectedAircraftModelOption"
                                            (selectionChange)="onAircraftModelSelected($event.value)"
                                        ></ds-select>
                                        <div *ngIf="loginForm.submitted && vehicle_name.invalid" class="invalid-feedback">
                                            <div *ngIf="vehicle_name.errors?.required">
                                                <span style="color: red">
                                                    {{ serviceType == 'Ground' ? 'Vehicle' : 'Aircraft' }} name required.</span
                                                >
                                            </div>
                                        </div>
                                    </ng-container>

                                    <ng-template #vehicleNameInput>
                                        <input
                                            id="vehiclename"
                                            class="form-control"
                                            #vehicle_name="ngModel"
                                            maxlength="45"
                                            name="vehicle_name"
                                            required
                                            type="text"
                                            [ngClass]="{ 'is-invalid': loginForm.submitted && vehicle_name.invalid }"
                                            [placeholder]="vehicleTitle"
                                            [(ngModel)]="vehicle.vehicleName"
                                        />
                                        <div *ngIf="loginForm.submitted && vehicle_name.invalid" class="invalid-feedback">
                                            <div *ngIf="vehicle_name.errors.required">
                                                <span style="color: red">
                                                    {{ serviceType == 'Ground' ? 'Vehicle' : 'Aircraft' }} name required.</span
                                                >
                                            </div>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label
                                        >Make<span class="text-danger"><b>*</b></span></label
                                    >
                                    <input
                                        id="vehiclemake"
                                        class="form-control"
                                        #vehicle_Make="ngModel"
                                        maxlength="45"
                                        name="vehicle_Make"
                                        placeholder="Make"
                                        required
                                        type="text"
                                        [ngClass]="{ 'is-invalid': loginForm.submitted && vehicle_Make.invalid }"
                                        [(ngModel)]="vehicle.companyName"
                                    />
                                    <div *ngIf="loginForm.submitted && vehicle_Make.invalid" class="invalid-feedback">
                                        <div *ngIf="vehicle_Make.errors.required"><span style="color: red"> Make is required.</span></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label
                                        >Model<span class="text-danger"><b>*</b></span></label
                                    >
                                    <ng-container *ngIf="serviceType == 'Air'; else modelInput">
                                        <input
                                            id="modelname"
                                            class="form-control"
                                            name="model_name"
                                            type="text"
                                            placeholder="Model"
                                            [disabled]="true"
                                            [(ngModel)]="vehicle.model"
                                        />
                                    </ng-container>
                                    <ng-template #modelInput>
                                        <input
                                            id="modelname"
                                            class="form-control"
                                            #model_name="ngModel"
                                            maxlength="45"
                                            name="model_name"
                                            placeholder="Model"
                                            required
                                            type="text"
                                            [ngClass]="{ 'is-invalid': loginForm.submitted && model_name.invalid }"
                                            [(ngModel)]="vehicle.model"
                                        />
                                        <div *ngIf="loginForm.submitted && model_name.invalid" class="invalid-feedback">
                                            <div *ngIf="model_name.errors.required">
                                                <span style="color: red"> Model is required. </span>
                                            </div>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label
                                        >{{ vehicleNumberTitle }} <span class="text-danger"><b>*</b></span></label
                                    >
                                    <input
                                        id="vehicle_no"
                                        class="form-control"
                                        #vehicle_no="ngModel"
                                        maxlength="45"
                                        name="vehicle_no"
                                        required
                                        type="text"
                                        [ngClass]="{ 'is-invalid': loginForm.submitted && vehicle_no.invalid }"
                                        [placeholder]="serviceType == 'Ground' ? 'Plate Number' : 'Tail#'"
                                        [(ngModel)]="vehicle.vehicleNumber"
                                    />
                                    <div *ngIf="loginForm.submitted && vehicle_no.invalid" class="invalid-feedback">
                                        <div *ngIf="vehicle_no.errors.required">
                                            <span style="color: red">
                                                {{ serviceType == 'Ground' ? 'Plate' : 'Tail' }} Number is required.
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label
                                        >Category<span class="text-danger"><b>*</b></span></label
                                    >
                                    <select
                                        id="category"
                                        class="form-control"
                                        #category="ngModel"
                                        name="category"
                                        required
                                        [ngClass]="{ 'is-invalid': loginForm.submitted && category.invalid }"
                                        [(ngModel)]="vehicle.aircraftCategoryId"
                                    >
                                        <option disabled value="">Select Category</option>
                                        <option
                                            *ngFor="let item of serviceType == 'Ground' ? vehicleCategory : aircraftCategoryList"
                                            [value]="item.appCategoryId"
                                        >
                                            {{ item?.name }}
                                        </option>
                                    </select>
                                    <div *ngIf="loginForm.submitted && category.invalid" class="invalid-feedback">
                                        <div *ngIf="category.errors.required"><span style="color: red">Category is required.</span></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label
                                        >Year <span *ngIf="selectedVendorDetails?.isContracted" class="text-danger"><b>*</b></span></label
                                    >
                                    <input
                                        id="year"
                                        class="form-control"
                                        #year="ngModel"
                                        maxlength="4"
                                        name="year"
                                        numbersOnly
                                        placeholder="Year"
                                        type="text"
                                        [ngClass]="{ 'is-invalid': loginForm.submitted && year.invalid }"
                                        [required]="selectedVendorDetails?.isContracted"
                                        [(ngModel)]="vehicle.year"
                                    />
                                    <div
                                        *ngIf="selectedVendorDetails?.isContracted && loginForm.submitted && year.invalid"
                                        class="invalid-feedback"
                                    >
                                        <div *ngIf="year.errors.required"><span class="text-danger"> Year is required.</span></div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="isVinNumberFieldVisible" class="col-md-6">
                                <div class="form-group">
                                    <label>VIN number</label>
                                    <input
                                        id="year"
                                        class="form-control"
                                        #vinNumber="ngModel"
                                        maxlength="17"
                                        minlength="17"
                                        name="vinNumber"
                                        pattern="^[A-Za-z0-9]{17}$"
                                        placeholder="VIN number"
                                        type="text"
                                        [ngClass]="{ 'is-invalid': loginForm.submitted && vinNumber.invalid }"
                                        [(ngModel)]="vehicle.vinNumber"
                                    />
                                    <div *ngIf="loginForm.submitted && vinNumber.invalid" class="invalid-feedback">
                                        <span style="color: red">VIN number must be exactly 17 alphanumeric characters.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label
                                        >Location
                                        <span *ngIf="selectedVendorDetails?.isContracted" class="text-danger"><b>*</b></span></label
                                    >
                                    <button
                                        id="addLocationPopUp"
                                        class="plus-icon"
                                        data-target="#addLocation"
                                        data-toggle="modal"
                                        title="Create Location"
                                        type="button"
                                        (click)="getStateList()"
                                        (click)="isCityButtonShow = false; isShowAddCity = false"
                                    >
                                        <i class="fa fa-plus-circle"></i>
                                    </button>
                                    <ngx-select-dropdown
                                        id="originDropDown"
                                        #location1="ngModel"
                                        name="location1"
                                        tabindex="0"
                                        [config]="mapOriginConfig"
                                        [multiple]="false"
                                        [ngClass]="{ 'is-invalid': loginForm.submitted && location1.invalid }"
                                        [options]="locationList"
                                        [required]="selectedVendorDetails?.isContracted"
                                        [(ngModel)]="addressName"
                                        (change)="selectAddress($event)"
                                    ></ngx-select-dropdown>
                                    <div
                                        *ngIf="selectedVendorDetails?.isContracted && loginForm.submitted && location1.invalid"
                                        class="invalid-feedback"
                                    >
                                        <div *ngIf="location1.errors.required"><span class="text-danger">Location is required.</span></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Upload Picture </label>
                                    <label class="d-flex">
                                        <input
                                            id="uploadProfilePicture"
                                            class="mt-2 cursorPointer"
                                            accept=".jpg,.jpeg,.png,.pdf"
                                            name="uploadProfilePicture"
                                            type="file"
                                            [style.width]="vehicleImag == true && headerName == 'Edit' ? '85px' : '100%'"
                                            [(ngModel)]="uploadPicture"
                                            (input)="bindFileName(uploadPicture)"
                                        />
                                        <span
                                            *ngIf="vehicleImag == true && headerName == 'Edit'"
                                            id="logoName"
                                            class="imageName mt-2 ml-2"
                                            >{{ vehicle?.filePath }}</span
                                        >
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="serviceType == 'Ground'" class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Upload Insurance</label>
                                    <label class="d-flex">
                                        <input
                                            id="insuranceFile"
                                            class="mt-2 cursorPointer"
                                            #insuranceFileInput
                                            accept=".jpg,.jpeg,.png,.pdf"
                                            name="insuranceFile"
                                            type="file"
                                            [style.width]="
                                                (selectedInsuranceFiles.length > 0 || insuranceFile != undefined) && headerName == 'Edit'
                                                    ? '85px'
                                                    : '100%'
                                            "
                                            (input)="setInsuranceFile('insuranceFile')"
                                        />
                                        <span
                                            *ngIf="
                                                (selectedInsuranceFiles.length > 0 || insuranceFile != undefined) && headerName == 'Edit'
                                            "
                                            class="imageName mt-2 ml-2"
                                        >
                                            {{ selectedInsuranceFiles[0]?.displayName }}
                                        </span>
                                        <span
                                            *ngIf="selectedInsuranceFiles.length == 0 && insuranceFile != undefined && headerName == 'Edit'"
                                            class="imageName mt-2 ml-2"
                                        >
                                            {{ insuranceFile?.displayName }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label
                                        >Insurance Expiration Date
                                        <span *ngIf="selectedVendorDetails?.isContracted" class="text-danger"><b>*</b></span></label
                                    >
                                    <div class="datetimepicker endtimeDate">
                                        <div class="datetimepicker endtimeDate" (click)="initializeInsuranceExpirationDateDatepicker()">
                                            <input
                                                id="insuranceExpirationDate"
                                                class="form-control"
                                                #insuranceExpirationDate="ngModel"
                                                autocomplete="off"
                                                name="insuranceExpirationDate"
                                                placeholder="Insurance Expiration Date"
                                                type="text"
                                                [ngModel]="insuranceExpirationTimeDatepicker"
                                                [required]="selectedVendorDetails?.isContracted"
                                                (ngModelChange)="insuranceExpirationTime = $event"
                                            />
                                            <i class="fa fa-calendar calendar-icon"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>
                                        {{ serviceType == 'Ground' ? 'Upload Registration' : 'Upload Safety Credentials' }}
                                    </label>
                                    <label class="d-flex">
                                        <input
                                            id="registrationFile"
                                            class="mt-2 cursorPointer"
                                            #registrationFileInput
                                            accept=".jpg,.jpeg,.png,.pdf"
                                            name="registrationFile"
                                            type="file"
                                            [style.width]="
                                                (selectedRegistrationFiles.length > 0 || registrationFile != undefined) &&
                                                headerName == 'Edit'
                                                    ? '85px'
                                                    : '100%'
                                            "
                                            (input)="setRegistrationFile('registrationFile')"
                                        />
                                        <span
                                            *ngIf="
                                                (selectedRegistrationFiles.length > 0 || registrationFile != undefined) &&
                                                headerName == 'Edit'
                                            "
                                            class="imageName mt-2 ml-2"
                                        >
                                            {{ selectedRegistrationFiles[0]?.displayName }}
                                        </span>
                                        <span
                                            *ngIf="
                                                selectedRegistrationFiles.length == 0 &&
                                                registrationFile != undefined &&
                                                headerName == 'Edit'
                                            "
                                            class="imageName mt-2 ml-2"
                                        >
                                            {{ registrationFile?.displayName }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label
                                        >{{ registrationExpirationTitle }}
                                        <span *ngIf="selectedVendorDetails?.isContracted" class="text-danger"> <b>*</b></span></label
                                    >
                                    <div class="datetimepicker endtimeDate">
                                        <div class="datetimepicker endtimeDate" (click)="initializeRegistrationExpirationDatepicker()">
                                            <input
                                                id="registrationExpirationDate"
                                                class="form-control form-control-datepicker"
                                                #registrationExpirationDate="ngModel"
                                                autocomplete="off"
                                                name="registrationExpirationDate"
                                                type="text"
                                                [ngModel]="registrationExpirationDatepicker"
                                                [placeholder]="registrationExpirationTitle"
                                                [required]="selectedVendorDetails?.isContracted"
                                            />
                                            <i class="fa fa-calendar calendar-icon"></i>
                                        </div>
                                    </div>
                                    <div
                                        *ngIf="registrationExpirationDate.touched && registrationExpirationDate.hasError('required')"
                                        class="text-danger"
                                    >
                                        {{ registrationExpirationTitle }} is required.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-12">
                                    <label>Description</label>
                                    <textarea
                                        id="des"
                                        class="form-control h-w"
                                        maxlength="256"
                                        name="description"
                                        placeholder="Description"
                                        [(ngModel)]="vehicle.description"
                                        (ngModelChange)="descriptionSize($event)"
                                    ></textarea>
                                    <div *ngIf="display == true">
                                        <span style="color: red">Description must not exceed 255 characters.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                            data-dismiss="modal"
                            type="button"
                            (click)="resetForm(loginForm); clearVehicleData(); emitPopupCloseEvent()"
                        >
                            Cancel
                        </button>
                        <button
                            *ngIf="headerName == 'Add'"
                            class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                            type="submit"
                            [disabled]="isSaveDisabled"
                            (click)="addVehicleDetails(serviceType, loginForm)"
                        >
                            Save Changes
                        </button>
                        <button
                            *ngIf="headerName == 'Edit'"
                            class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                            type="submit"
                            [disabled]="isSaveDisabled"
                            (click)="editVehicleDetails(serviceType, loginForm)"
                        >
                            Save Changes
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div id="addLocation" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    class="close close-btn"
                    aria-label="Close"
                    data-dismiss="modal"
                    type="button"
                    (click)="closeLocation('addLocation'); resetLocationForm(addLocationForm)"
                >
                    <i class="fa fa-close"></i>
                </button>
                <h4 class="modal-title">Create Location</h4>
            </div>
            <form #addLocationForm="ngForm" name="addLocationForm">
                <div class="modal-body">
                    <div class="member-card">
                        <h4 class="filter-options">Address Details</h4>
                        <hr class="hr-class" />

                        <div class="col-md-12">
                            <div class="row">
                                <input
                                    id="autocompleteAddress"
                                    class="form-control autocomplete-addr"
                                    #pick
                                    name="searchAddr"
                                    placeholder="Search"
                                    type="text"
                                    [(ngModel)]="searchedAddr"
                                    (ngModelChange)="autoSearchAddress()"
                                />
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-12">
                                <label>Location Name</label><span class="text-danger"> * </span>
                                <input
                                    id="addressName"
                                    class="form-control"
                                    maxlength="255"
                                    name="addressName"
                                    placeholder="Location Name"
                                    required
                                    type="text"
                                    [(ngModel)]="Location.addressName"
                                />
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-6">
                                <label>Address Type</label><span class="text-danger"> * </span>
                                <select
                                    class="form-control"
                                    #addressType="ngModel"
                                    name="addressType"
                                    required
                                    [ngClass]="{ 'is-invalid': addLocationForm.submitted && addressType.invalid }"
                                    [(ngModel)]="Location.LocationAddressType"
                                >
                                    <option disabled selected [value]="null">Select Address Type</option>
                                    <option *ngFor="let item of AddressType" name="addr_type" [value]="item">
                                        {{ item }}
                                    </option>
                                </select>
                                <div *ngIf="addLocationForm.submitted && addressType.invalid" class="invalid-feedback">
                                    <div *ngIf="addressType.errors.required"><span style="color: red">Address Type is required.</span></div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Address</label><span class="text-danger"> * </span>
                                    <div class="radio my-0">
                                        <label>
                                            <input
                                                #pvtOrPublic="ngModel"
                                                name="pvtOrPublic"
                                                type="radio"
                                                [value]="false"
                                                [(ngModel)]="Location.isGlobal"
                                            />Private
                                        </label>
                                        <label class="ml-4">
                                            <input
                                                #pvtOrPublic="ngModel"
                                                name="pvtOrPublic"
                                                type="radio"
                                                [value]="true"
                                                [(ngModel)]="Location.isGlobal"
                                            />Public
                                        </label>
                                        <label class="ml-4">
                                            <input
                                                #pvtOrPublic="ngModel"
                                                name="pvtOrPublic"
                                                type="radio"
                                                [value]="null"
                                                [(ngModel)]="Location.isGlobal"
                                            />Airport
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="Location.isGlobal == null" class="row form-group">
                            <div class="col-md-6">
                                <label>Airport Code </label><span class="text-danger"> * </span>
                                <button
                                    *ngIf="!isShowAddAirportCode"
                                    id="addAirportCode"
                                    class="plus-icon"
                                    title="Add Airport Code"
                                    type="button"
                                    (click)="isShowAddAirportCode = true"
                                >
                                    <i class="fa fa-plus-circle"></i>
                                </button>
                                <button
                                    *ngIf="isShowAddAirportCode"
                                    class="plus-icon"
                                    title="Cancel Add Airport Code"
                                    type="button"
                                    (click)="isShowAddAirportCode = false; airport = ''"
                                >
                                    <i class="fa fa-times-circle"></i>
                                </button>
                                <div *ngIf="isShowAddAirportCode">
                                    <div class="col-md-8 px-0">
                                        <input
                                            class="form-control"
                                            #airportCodeName="ngModel"
                                            maxlength="4"
                                            name="airportCodeName"
                                            placeholder="Enter Airport Code"
                                            required
                                            type="text"
                                            [value]="airport | uppercase"
                                            [(ngModel)]="airport"
                                        />
                                    </div>
                                    <div class="col-md-4 pr-0">
                                        <button
                                            class="flat-butt flat-info-butt flat-info-grad-butt btn-size save-btn col-md-12"
                                            type="submit"
                                            (click)="isShowAddAirportCode = false; addAirportCode()"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                                <select
                                    *ngIf="!isShowAddAirportCode"
                                    class="form-control"
                                    #airportCode="ngModel"
                                    name="airportCode"
                                    required
                                    [ngClass]="{ 'is-invalid': addLocationForm.submitted && airportCode.invalid }"
                                    [(ngModel)]="Location.airportCode"
                                >
                                    <option disabled selected [value]="null">Select Airport Code</option>
                                    <option *ngFor="let item of airportCodeList" name="state" [value]="item.airportCode">
                                        {{ item?.airportCode }}
                                    </option>
                                </select>
                                <!--todo commented as no details for airportCode-->
                                <!--<div *ngIf="addLocationForm.submitted && airportCode && airportCode.invalid"
                                    class="text-danger">
                                    <div *ngIf="airportCode.errors.required">
                                        <span class="text-danger">
                                            Airport Code is required.
                                        </span>
                                    </div>
                                </div>-->
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-6">
                                <label>Street Address</label><span class="text-danger"> * </span>
                                <input
                                    id="CMStreetAddress"
                                    class="form-control"
                                    name="streetAddress"
                                    placeholder="Street Address"
                                    type="text"
                                    [(ngModel)]="Location.streetAddress"
                                />
                            </div>
                            <div class="col-md-6">
                                <label>Zipcode</label><span class="text-danger"> * </span>
                                <input
                                    id="CMZipcode"
                                    class="form-control"
                                    #zipCode="ngModel"
                                    maxlength="5"
                                    minlength="3"
                                    name="Zipcode"
                                    pattern="[A-Za-z0-9]+"
                                    placeholder="Zipcode"
                                    type="text"
                                    [(ngModel)]="Location.zipcode"
                                />
                                <div *ngIf="addLocationForm.submitted && zipCode.invalid" class="invalid-feedback">
                                    <div *ngIf="zipCode.errors.pattern">
                                        <span style="color: red">ZipCode not valid.</span>
                                    </div>
                                    <div *ngIf="zipCode.errors.minlength">
                                        <span style="color: red">ZipCode must have 3 or 5 digits.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-6">
                                <label>State</label><span class="text-danger"> * </span>
                                <select
                                    class="form-control"
                                    #stateName="ngModel"
                                    name="state"
                                    [(ngModel)]="Location.stateId"
                                    (change)="getCityByState(Location.stateId)"
                                >
                                    <option disabled selected value="">Select State</option>
                                    <option *ngFor="let item of stateListForMember" [value]="item.stateId">
                                        {{ item?.stateName }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label>City</label><span class="text-danger"> * </span>
                                <button
                                    *ngIf="isCityButtonShow && !isShowAddCity"
                                    id="addLocationPopUp"
                                    class="plus-icon"
                                    title="Add City"
                                    type="button"
                                    (click)="isShowAddCity = true"
                                >
                                    <i class="fa fa-plus-circle"></i>
                                </button>
                                <button
                                    *ngIf="isShowAddCity"
                                    class="plus-icon"
                                    title="Cancle Add City"
                                    type=" button"
                                    (click)="isShowAddCity = !isShowAddCity"
                                >
                                    <i class="fa fa-times-circle"></i>
                                </button>
                                <div *ngIf="isShowAddCity">
                                    <div class="col-md-8 px-0">
                                        <input
                                            class="form-control"
                                            name="city"
                                            placeholder="Enter City Name"
                                            type="text"
                                            [(ngModel)]="city.cityName"
                                        />
                                    </div>
                                    <div class="col-md-4 pr-0">
                                        <button
                                            class="flat-butt flat-info-butt flat-info-grad-butt btn-size save-btn col-md-12"
                                            type="submit"
                                            (click)="addCity()"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                                <select *ngIf="!isShowAddCity" class="form-control" name="state" [(ngModel)]="Location.cityId">
                                    <option disabled selected value="">Select City</option>
                                    <option *ngFor="let item of cityList" name="city" [value]="item.cityId">
                                        {{ item?.cityName }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                        class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                        type="button"
                        (click)="closeLocation('addLocation'); clearLocation(); resetLocationForm(addLocationForm)"
                    >
                        Cancel
                    </button>
                    <button
                        class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                        type="submit"
                        (click)="addLocation(Location, addLocationForm)"
                    >
                        Save Changes
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
